import { SingleDataLoader } from 'components/Atoms/SingleDataLoader'
import { UserOverviewPanelCSS } from './UserOverviewPanelCSS.styled'
import { config } from 'config/index'
import { Link } from 'components/Atoms/Link'
import { UserOverview } from 'components/Molecules/userProfileOverview/UserOverview'
import { useEffect } from 'react'

const { YOLO_BASE_URL, REDDIT_CLIENT_ID } = config

const DURATION = 'permanent'
const SCOPE = 'identity flair history wikiread'
const REDIRECT_URI = `${YOLO_BASE_URL}/game/reddit/link`
const RANDOM_STRING = 'randomestringhere'
const RESPONSE_TYPE = 'code'

const REDDIT_LINK_URL = `https://www.reddit.com/api/v1/authorize?client_id=${REDDIT_CLIENT_ID}&response_type=${RESPONSE_TYPE}&state=${RANDOM_STRING}&redirect_uri=${REDIRECT_URI}&duration=${DURATION}&scope=${SCOPE}`

export const UserOverviewPanel = (props) => {
  const handleFocus = () => {
    props.refreshData()
  }

  useEffect(() => {
    window.addEventListener('focus', handleFocus)
    return () => {
      window.removeEventListener('focus', handleFocus)
    }
  })

  return (
    <UserOverviewPanelCSS>
      <UserOverview {...props} />
      {/* <div className='content column'>
        <div className='subtitle'>REDDIT</div>
        <SingleDataLoader
          loading={props.isPending}
          data={
            <Link href={REDDIT_LINK_URL} className='link_reddit_account'>
              Link Reddit account
            </Link>
          }
        />
      </div> */}
    </UserOverviewPanelCSS>
  )
}
